
import React from 'react';
import _ from 'lodash';
import MemberServices from '../services/MemberService';
import { EVENT } from '../events/listEvents';
import $ from 'jquery';
import CommonUtil from '../common/CommonUtil';
import OddsPageAction from '../components/CompactView/OddsPageComponent/OddsPageActions';
import Constants from "../common/Constants";

export default class CommonActions {
  static renderWaitLoading = (skinName) => {
    const classNameAnniversary = CommonUtil.isLogo25YearEnabled(CommonUtil.getDatesRangeSpecialDate(Constants.LOGO_DATES_ANNIVERSARY_KEY)) ? 'anniversary' : '';
    return (
        <div id={skinName + "_loading"} className="first-loading">
          <div className="default_loading"/>
          <div
              className={`loading_logo ${CommonUtil.getLangByPath(window.location.pathname)} ${classNameAnniversary}`}/>
          <div className="progress-bar"/>
        </div>
    )
  }

  static lazyWithPreload(factory) {
    const Component = React.lazy(factory);
    Component.preload = factory;
    return Component;
  }

  static injectScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.type  = "text/javascript";
      script.src = src;
      script.addEventListener('load', resolve);
      script.addEventListener('error', () => reject('Error loading script.'));
      script.addEventListener('abort', () => reject('Script loading aborted.'));
      document.head.appendChild(script);
    });
  }
  static injectExternalCssLink (url) {
    return new Promise((resolve, reject) => {

      let extLink = document.createElement("link");
  
      extLink.type = "text/css";
      extLink.rel = "preload stylesheet";
      extLink.as = "style";
      extLink.charset="UTF-8"
      extLink.onload = function() {
        extLink.rel = "stylesheet";
        resolve(extLink)
      }
      extLink.onerror = function (){
        reject(new Error(`Script load error for ${url}`));
      }
      extLink.href = url;
      document.head.appendChild(extLink);
    });
  }

  static serialize(form) {
    if (!form || form.nodeName !== "FORM") {
      return
    }
    var i, j, dataForm = {}
    for (i = form.elements.length - 1; i >= 0; i = i - 1) {
      if (form.elements[i].name === "") {
        continue
      }
      switch (form.elements[i].nodeName) {
        case 'INPUT':
          switch (form.elements[i].type) {
            case 'text':
            case 'tel':
            case 'email':
            case 'hidden':
            case 'password':
            case 'button':
            case 'reset':
            case 'submit':
              dataForm[form.elements[i].name] = form.elements[i].value
              break
            case 'checkbox':
            case 'radio':
              if (form.elements[i].checked) {
                dataForm[form.elements[i].name] = form.elements[i].value
              }
              break
            default:
              break
          }
          break
        case 'file':
          break
        case 'TEXTAREA':
          dataForm[form.elements[i].name] = form.elements[i].value
          break
        case 'Select':
          switch (form.elements[i].type) {
            case 'select-one':
              dataForm[form.elements[i].name] = form.elements[i].value
              break
            case 'select-multiple':
              let options = []
              for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                if (form.elements[i].options[j].selected) {
                  options.push(form.elements[i].options[j].value)
                }
              }
              dataForm[form.elements[i].name] = options
              break
            default:
              break
          }
          break
        case 'SELECT':
          for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
            if (form.elements[i].options[j].selected) {
              dataForm[form.elements[i].name] = form.elements[i].options[j].value
            }
          }
          break
        case 'BUTTON':
          switch (form.elements[i].type) {
            case 'reset':
            case 'submit':
            case 'button':
              dataForm[form.elements[i].name] = form.elements[i].value
              break
            default:
              break
          }
          break
        default:
          break
      }
    }
    return dataForm
  }

  static async loadCaptchaImage(moduleName) {
    return await MemberServices.getCaptchaImage(moduleName).then(response => {
      if (response.data) {
        return response.data
      }
      return null
    }).catch(error => {
      console.log("Load Captchar error: ", error)
      return null
    })
  }

  static getAllUrlParams(url) {
    // get query string from url (optional) or window
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    let obj = {};

    // if query string exists
    if (queryString) {

      // stuff after # is not part of query string, so get rid of it
      queryString = queryString.split('#')[0];

      // split our query string into its component parts
      let arr = queryString.split('&');

      for (let i = 0; i < arr.length; i++) {
        // separate the keys and the values
        let a = arr[i].split('=');

        // in case params look like: list[]=thing1&list[]=thing2
        let paramNum = undefined;
        let paramName = a[0].replace(/\[\d*\]/, function (v) {
          paramNum = v.slice(1, -1);
          return '';
        });

        // set parameter value (use 'true' if empty)
        let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

        // (optional) keep case consistent
        paramName = paramName.toLowerCase();
        paramValue = paramValue.toString().toLowerCase();

        // if parameter name already exists
        if (obj[paramName]) {
          // convert value to array (if still string)
          if (typeof obj[paramName] === 'string') {
            obj[paramName] = [obj[paramName]];
          }
          // if no array index number specified...
          if (typeof paramNum === 'undefined') {
            // put the value on the end of the array
            obj[paramName].push(paramValue);
          }
          // if array index number specified...
          else {
            // put the value at that index number
            obj[paramName][paramNum] = paramValue;
          }
        }
        // if param name doesn't exist yet, set it
        else {
          obj[paramName] = paramValue;
        }
      }
    }

    return obj;
  }

  static getCssFile(tempData, currentViewContainer) {
		const cssLink = tempData.cssFile;
		const currentView = currentViewContainer || '';
		switch (currentView) {
			case "classicView":
				return cssLink.classic;
			case "compactView":
				return cssLink.pa;
			default:
				return cssLink.pa
		}
	}

  static actionWithBrowser(tempData) {
    /** trick for by pass server vanish caching */
    const style = _.find(document.styleSheets, styleSheet => styleSheet.href && styleSheet.href.includes("static/css/main"));
    const versionBuild = style && style.href ? style.href.split("/").pop() : window.versionBuild;
    window.versionBuild = versionBuild;

    // const head = document.head;
    let cssFonts = tempData.cssFontFile;
    if (cssFonts) {
      cssFonts = process.env.PUBLIC_URL + '/' + cssFonts + '?v=' + versionBuild;
    }
    const linkCssFont = document.createElement("link");

    linkCssFont.type = "text/css";
    // linkCssFont.rel = "stylesheet";
    linkCssFont.rel = "preload stylesheet";
    linkCssFont.id = "font-stylesheet";
    linkCssFont.href = cssFonts;
    linkCssFont.as = "style";
    linkCssFont.onload = function () {
      linkCssFont.onload = null;
      linkCssFont.rel = "stylesheet";
    }
    document.head.appendChild(linkCssFont);
    let cssFiless;
    //waiting css loadind finish. after css loaded, render UI
    const cssLink = CommonActions.getCssFile(tempData);

    if (cssLink.startsWith("http") || cssLink.startsWith("https")) {
      cssFiless = cssLink;
    } else {
      cssFiless = process.env.PUBLIC_URL + '/' + cssLink;
    }

    const link = document.createElement("link");
    link.type = "text/css";
    // link.rel = "stylesheet";
    link.id = "skin-stylesheet";
    link.rel = "preload stylesheet";
    link.href = cssFiless + '?v=' + versionBuild;
    link.as = "style";
    link.onload = function () {
      link.onload = null;
      link.rel = "stylesheet";
      // setTimeout(() => {
      window.fireEvent(EVENT.CSS_LOADED)
      // }, 500)
    }
    document.head.appendChild(link);
  }

  static listenWidgetClose (){
    $('#freshwidget-close').on("click",function(){
      CommonActions.inactiveScroll(false);
      $('body').attr("style","");
    })
    $('#freshwidget-overlay').on("click",function(){
      CommonActions.inactiveScroll(false);
      $('body').attr("style","");
    })
  }

  static inactiveScroll (isInactive){
    const htmlDoc = document.querySelector('html');
    if (isInactive) {
      htmlDoc.style.overflow = 'hidden';
      htmlDoc.style.marginRight = '17px';
    } else {
      htmlDoc.style.cssText = "";
    }
  }

   /**
  * Init gameflex express library of iforium game
  */
 static initGameflexExpressLibray() {
    return MemberServices.initGameflexExpressLibrayAPI().then(response => {
      return response.data;
    }).catch(error => {
      console.log("Cannot load Gameflex Express Libray configuration: " + error);
      throw error;
    });
  }

 
  /**
  * Get Player session for Golden Race VS game
  * @param {*} gameId
  */
 static async getPlayerSessionVs(gameId) {   
  return await MemberServices.getPlayerSessionVsAPI(gameId).then(response => {
    return response.data;
  }).catch(error => {
    console.log("Cannot load getPlayerSession: " + error);
    throw error;
  });
}

  /**
  * Get Default gameId for Golden Race VS game
  * @param {*} channelId
  */
 static async getDefaultGameIdGRVs(channelId) {   
  return await MemberServices.getDefaultGameIdGRVsAPI(channelId).then(response => {
    return response.data;
  }).catch(error => {
    console.log("Cannot load getDefaultGameIdGRVs: " + error);
    throw error;
  });
}

  static openFreshWidget() {
    if (!window.FreshWidget) {
      this.injectScript("//assets.freshdesk.com/widget/freshwidget.js").then(() => {
        window.FreshWidget.init("", { "loadOnEvent": 'immediate', "queryString": "&widgetType=popup&formTitle=Help", "utf8": "?", "widgetType": "popup", "buttonType": "text", "buttonText": "Support", "buttonColor": "white", "buttonBg": "#f96500", "alignment": "4", "offset": "235px", "formHeight": "500px", "url": "//zh-cn.help.pinnacle888.com" });
        this.showFreshWidget();
        this.listenWidgetClose();
      })
    } else {
      this.showFreshWidget();
    }
  }

  static showFreshWidget() {
    //set up Fresh widget
    this.inactiveScroll(true);
    window.FreshWidget.show();
  }

  static async getAllLiveTVEvents(domain) {
    return OddsPageAction.getAllLiveTVEvents(domain, -1);
  }

}


// WEBPACK FOOTER //
// ./src/app/actions/CommonActions.js